import React from 'react';
import { Comment } from '../types/comment';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface CommentContextProps {
  comments: Map<string, Map<string, Comment>>;
  setComments: (comments: Map<string, Map<string, Comment>>) => void;
  commentsLoading: boolean;
}

const defaultContext: CommentContextProps = {
  comments: new Map(),
  setComments: () => {},
  commentsLoading: false,
};

export const CommentContext = React.createContext<CommentContextProps>(defaultContext);

interface CommentState {
  items: Record<string, any>[];
  loading: boolean;
}

export const commentSlice = createSlice({
  name: 'comment',
  initialState: { items: [], loading: true } as CommentState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    set: (state, action: PayloadAction<Comment[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    add: (state, action: PayloadAction<Comment[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    delete: (state, action: PayloadAction<Comment[]>) => {
      const idsToDelete = new Set(action.payload.map(c => c.id));
      state.items = [...state.items.filter(c => !idsToDelete.has(c.id))];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
